export default __webpack_public_path__ + "static/media/icon-13.4504bf33.svg";